var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js
// module id = 1441
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 17 18 19 20 21